import React from "react";
import RecorderJS from "recorder-js";
import { connect } from "react-redux";
import { getAudioStream, exportBuffer } from "../../../../../common/audio";
import { LUCIA_TENANT_NAME } from "../../../../../constants";

// Material ui
import IconButton from "@material-ui/core/IconButton";

// Microphone Icon
import MicListeningBtn from "./MicListeningBtn";

import axios from "axios";

const VOICE_PROCESSING = "GOOGLE"; // GOOGLE or AMAZON

function show_some_data(given_typed_array, num_row_to_display, label) {
  let size_buffer = given_typed_array.length;
  let index = 0;
  // console.log("__________ " + label);
  if (label === "time") {
    for (; index < num_row_to_display && index < size_buffer; index += 1) {
      let curr_value_time = given_typed_array[index] / 128 - 1.0;
      return curr_value_time;
    }
  } else if (label === "frequency") {
    for (; index < num_row_to_display && index < size_buffer; index += 1) {
      return given_typed_array[index];
    }
  } else {
    throw new Error("ERROR - must pass time or frequency");
  }
}

// let final;
// let seconds = 0;

class Recorder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      permission: null,
      stream: null,
      recording: false,
      continuousRecording: false,
      recorder: null,
      silenceStart: undefined
    };
    this.apiUrl = "https://speech.googleapis.com/v1/speech:recognize?key=AIzaSyDOGOHsyXXmM7LFHMIVrsvKp6JotGXneNw";
  }

  async process_microphone_buffer(event) {
    let i, N, inp, microphone_output_buffer;

    microphone_output_buffer = event.inputBuffer.getChannelData(0); // just mono - 1 channel for now
    // if (!final) {
    //   final = microphone_output_buffer;
    // } else {
    //   final = Float32Concat(final, microphone_output_buffer);
    // }

    // if (seconds === 10 && this.state.recording) {
    //   seconds = 0;
    //   let audio = await exportBuffer(final, VOICE_PROCESSING);
    //   this.handleOnRecordingIconClickGoogle(audio);
    // }
    //
    // seconds = seconds + 1;
    // console.log("microphone_buffer ", microphone_output_buffer);
  }

  startRecord() {
    // console.log("Start Recording", this.props.continuousRecording);
    if (this.state.continuousRecording) {
      const { stream } = this.state;
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const recorder = new RecorderJS(audioContext);

      let gain_node = audioContext.createGain();
      gain_node.gain.value = 0;
      gain_node.connect(audioContext.destination);

      let microphone_stream = audioContext.createMediaStreamSource(stream);
      microphone_stream.connect(gain_node);

      let script_processor_node = audioContext.createScriptProcessor(16384, 1, 1);
      script_processor_node.onaudioprocess = this.process_microphone_buffer;

      microphone_stream.connect(script_processor_node);

      let script_processor_analysis_node = audioContext.createScriptProcessor(4096, 1, 1);
      script_processor_analysis_node.connect(gain_node);

      let analyser_node = audioContext.createAnalyser();
      analyser_node.smoothingTimeConstant = 0.85; // was 0 before
      analyser_node.fftSize = 2048;
      analyser_node.minDecibels = -90;
      analyser_node.maxDecibels = -10;

      microphone_stream.connect(analyser_node);

      analyser_node.connect(script_processor_analysis_node);

      let buffer_length = analyser_node.frequencyBinCount;

      let array_freq_domain = new Uint8Array(buffer_length);
      let array_time_domain = new Uint8Array(buffer_length);

      recorder.init(stream);
      this.setState(
        {
          recorder,
          recording: true,
          silenceStart: undefined,
          recordingStarted: Date.now()
        },
        () => {
          recorder.start().then(() => {
            // let silence_start;
            // console.log("Silence start", silence_start)
            script_processor_analysis_node.onaudioprocess = event => {
              // this.process_microphone_buffer(event);
              if (!this.state.continuousRecording) {
                microphone_stream.disconnect();
                analyser_node.disconnect();
                script_processor_node.disconnect();
                script_processor_analysis_node.disconnect();
                script_processor_node.onaudioprocess = null;
              }

              // get the average for the first channel
              analyser_node.getByteFrequencyData(array_freq_domain);
              analyser_node.getByteTimeDomainData(array_time_domain);

              // draw the spectrogram
              if (
                microphone_stream.playbackState == microphone_stream.PLAYING_STATE &&
                this.state.recording &&
                this.props.playingState !== "playing"
              ) {
                // console.log(this.state.continuousRecording);
                this.props.onRecordingStateChange("RECORDING");
                // console.log("this.state.recording && this.props.playingState !== 'playing'");
                let frequency_data = show_some_data(array_freq_domain, 5, "frequency");
                let time_data = show_some_data(array_time_domain, 5, "time"); // store this to record to aggregate buffer/fil
                // examine array_time_domain for near zero values over some time period

                if (time_data > 0.01 || time_data < -0.01) {
                  // console.log("new start date");
                  this.setState({ silenceStart: Date.now() });
                }

                let elapsedTime = Date.now() - this.state.silenceStart;
                let timeLimitReached = Date.now() - this.state.recordingStarted;
                if (
                  elapsedTime > 1500 ||
                  timeLimitReached > 13000 ||
                  (timeLimitReached > 5000 && !this.state.silenceStart)
                ) {
                  // console.log("Silence detected", this.state.silenceStart);
                  this.setState(
                    {
                      recording: false
                    },
                    () => {
                      // check if there is not inactivity from the beginning
                      if (!(timeLimitReached > 5000 && !this.state.silenceStart)) {
                        this.stopRecord();
                      } else {
                        this.makeRecordingPassive();
                        this.setState({ continuousRecording: !this.state.continuousRecording });
                      }
                      // microphone_stream.disconnect();
                      // analyser_node.disconnect();
                      // script_processor_node.disconnect();
                      // script_processor_analysis_node.disconnect();
                      // script_processor_node.onaudioprocess = null;
                    }
                  );
                }
              }
            };
          });
        }
      );
    }
  }

  makeRecordingPassive() {
    this.props.onRecordingStateChange("");
    try {
      this.state.stream.getTracks()[0].stop();
      let audio = document.getElementById("responsum_audio");
      audio.currentTime = audio.duration;
    } catch (e) {
      // console.log("E", e);
    }
  }

  async stopRecord() {
    // console.log("Stop Recording");
    // final = null;
    const { recorder } = this.state;
    const { buffer } = await recorder.stop();
    const audio = await exportBuffer(buffer[0], VOICE_PROCESSING);
    // Do your audio processing here.exportBuffer

    // console.log("Audio", audio);

    if (VOICE_PROCESSING === "AMAZON") {
      this.props.submitVoice(audio);
      this.props.onRecordingStateChange("SENDING");
    } else if (VOICE_PROCESSING === "GOOGLE") {
      try {
        const audioBuffer = {
          content: audio
        };
        const config = {
          languageCode: "en-US",
          model: "command_and_search",
          ...this.getAdditionalConfigForGoogleSpeechToTextApiRequest(this.props.tenant)
        };
        const request = {
          audio: audioBuffer,
          config: config
        };

        axios
          .request({
            url: this.apiUrl,
            method: "POST",
            data: request
          })
          .then(response => {
            const transcription = response.data.results.map(result => result.alternatives[0].transcript).join("\n");
            const confidence = response.data.results.map(result => result.alternatives[0].confidence).join("\n");
            console.log(`Transcription: ${transcription}, Confidence: ${confidence}`);
            this.props.onRecordingStateChange("SENDING");
            this.props.submitText(transcription);
          })
          .catch(err => {
            console.log("err :", err);
            this.props.onRecordingStateChange("");
            this.setState({ continuousRecording: !this.state.continuousRecording });
            // console.log("this.state", this.state);
          });
      } catch (e) {
        console.log("E", e);
      }
    }
  }

  continuousRecordingWrapper() {
    if (this.state.recording) {
      this.stopRecord();
    } else {
      this.startRecord();
    }

    if (!this.state.continuousRecording) {
      this.makeRecordingPassive();
    }
  }

  enableMicrofonStream = async () => {
    let stream;
    try {
      // We will implement this later.
      stream = await getAudioStream();
      this.setState({ stream: stream, permission: true });
    } catch (error) {
      // Users browser doesn't support audio.
      // Add your handler here.
      this.setState({ permission: false });
      console.log(error);
    }
    // console.log("stream", this.state.stream);
  };

  handleOnRecordingIconClick() {
    // console.log("this.state handleOnRecordingIconClick", this.state);
    this.setState({ continuousRecording: !this.state.continuousRecording }, () => {
      if (this.state.continuousRecording) {
        this.enableMicrofonStream().then(() => {
          if (this.state.permission) {
            this.continuousRecordingWrapper();
          }
        });
      } else {
        if (this.state.permission) {
          this.setState({ recording: false }, () => {
            this.makeRecordingPassive();
          });
        }
      }
    });
  }

  getAdditionalConfigForGoogleSpeechToTextApiRequest(tenant) {
    if (tenant === LUCIA_TENANT_NAME) {
      return {
        speechContexts: [
          {
            phrases: ["male"]
          }
        ]
      };
    }

    return {};
  }

  handleOnRecordingIconClickGoogle(audio) {
    // Create a recognize stream

    const audioBuffer = {
      content: audio
    };

    const config = {
      languageCode: "en-US",
      ...this.getAdditionalConfigForGoogleSpeechToTextApiRequest(this.props.tenant)
    };

    const request = {
      audio: audioBuffer,
      config: config
    };

    axios
      .request({
        url: this.apiUrl,
        method: "POST",
        data: request
      })
      .then(response => {
        const transcription = response.data.results.map(result => result.alternatives[0].transcript).join("\n");
        const confidence = response.data.results.map(result => result.alternatives[0].confidence).join("\n");
        console.log(`${transcription}`);
        // this.props.submitText(transcription);
      })
      .catch(err => {
        console.log("err :", err);
      });
  }

  componentWillReceiveProps(nextProps, nextContext) {
    // console.log("nextProps.playingState", nextProps.playingState);
    // console.log("this.props.playingState", this.props.playingState);
    // console.log("this.state", this.state)
    if (
      nextProps.playingState === "stopped" &&
      this.props.playingState === "playing"
      // (this.props.playingState === "playing" || nextProps.playingState === "error")
    ) {
      this.continuousRecordingWrapper();
    }

    if (nextProps.playingState === "error" && this.props.playingState !== "error") {
      this.setState({ continuousRecording: !this.state.continuousRecording }, () => {
        this.makeRecordingPassive();
      });
    }

    if (nextProps.playingState === "bubble_clicked" && this.props.playingState !== "bubble_clicked") {
      if (this.state.continuousRecording) {
        this.setState({ continuousRecording: !this.state.continuousRecording, recording: false }, () =>
          this.makeRecordingPassive()
        );
      }
    }
  }

  render() {
    const { recording, stream, continuousRecording } = this.state;
    const { playingState } = this.props;

    // Don't show record button if their browser doesn't support it.
    // if (!stream) {
    //   return null;
    // }

    return (
      <IconButton
        onClick={() => {
          this.handleOnRecordingIconClick();
        }}
      >
        <MicListeningBtn
          recording={recording}
          stream={stream}
          playingState={playingState}
          listeningState={this.props.listeningState}
        />
      </IconButton>
    );
  }
}

const mapStateToProps = state => {
  return {
    tenant: state.skill.tenant
  };
};

export default connect(mapStateToProps)(Recorder);
